import { AllEventService } from './../../events/all-events/all-event.service';
import { Component, OnInit } from '@angular/core';
import { Speaker } from 'src/app/interfaces/Speaker.model';
import { Observable } from 'rxjs';
import { Webinar } from 'src/app/interfaces/webinars.model';
import { WebinarsUsersMapping } from 'src/app/interfaces/webinarsUsersMapping.module';

@Component({
  selector: 'app-admin-speaker',
  templateUrl: './admin-speaker.component.html',
  styleUrls: ['./admin-speaker.component.css']
})
export class AdminSpeakerComponent implements OnInit {
  speakersList: Observable<Speaker[]>;
  webinarList: WebinarsUsersMapping[];
  list1: string[] = [];
  constructor(private allEventsService: AllEventService) {}

  ngOnInit(): void {
    this.speakersList = this.allEventsService.getSpeakers();
    this.allEventsService.getAllWebinarsUsersMapping().subscribe((data) => {
      this.webinarList = data;
    });
  }

  findWebinars(speakerName) {
    this.list1 = [];
    this.webinarList.forEach((data) => {
      const sList = data.webinar.speakers;
      sList.forEach((i) => {
        if (i.contactInfo.name === speakerName) {
          this.list1.push('https://webiknowr.com/webinar/' + data.webinarId);
        }
      });
    });

    return this.list1;
  }
}
